import Header from './components/header';
import Features from './components/features';
import Footer from './components/footer';
import Solves from './components/solves';
import './App.css';

export default function pag() {
  return (
    <>
      <Header />
      <Features />
      <Solves />
      <Footer />
      

    </>
  )
}

 